function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { cx } from '@emotion/css';
import { poolStyle, prefix, notificationStyle } from "./index.style";
import { createComponentInstance, createPortalInstance } from "../../utils";
var messageApi = ['success'];

var getMessageInstance = function () {
  var instance;
  return function () {
    var _instance;

    if (Boolean((_instance = instance) === null || _instance === void 0 ? void 0 : _instance.isMounted)) {
      return instance;
    }

    instance = createPortalInstance();

    if (!instance.component) {
      var _initial = {
        isInitial: true,
        todo: null,
        update: function update(children) {
          _initial.todo = children;
        }
      };
      Object.defineProperty(instance, 'component', {
        get: function get() {
          return _initial;
        },
        set: function set(val) {
          var _initial$todo;

          if (!_initial.isInitial) {
            return;
          }

          if ((_initial$todo = _initial.todo) !== null && _initial$todo !== void 0 && _initial$todo.__fake_set) {
            val.update(_initial.todo);
          }

          _initial = val;
        }
      });
    }

    return instance;
  };
}();

var message = messageApi.reduce(function (total, apiName) {
  total[apiName] = function (content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var instance = getMessageInstance();
    instance.mount(NotificationPool, prefix(), {});
    var child = createComponentInstance({
      mount: function mount(comp, key, props) {
        child.container = /*#__PURE__*/React.createElement(comp, _objectSpread({
          key: key
        }, props));
      },
      unMount: function unMount() {
        child.container = null;
        instance.children.delete(child);

        if (instance.children.size === 0) {
          instance.unMount();
        } else {
          instance.component.update(instance.children);
        }
      }
    });

    var mount = function mount() {
      instance.children.push(child, [Notification, prefix() +
      /* String(instance.children.size) */
      Date.now(), _objectSpread(_objectSpread({}, options), {}, {
        content: content,
        unMount: unMount
      })]);
      instance.component.update(instance.children);
    };

    var unMount = function unMount() {
      if (options.duration !== undefined) {
        return;
      }

      child.unMount();
    };

    return {
      unMount: unMount,
      mount: mount
    };
  };

  return total;
}, {});
var NotificationPool = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      children = _React$useState2[0],
      updateChildren = _React$useState2[1];

  React.useImperativeHandle(ref, function () {
    return {
      update: function update(value) {
        var newChildren = [];
        value.forEach(function (instance) {
          if (!(instance.container instanceof HTMLElement)) {
            newChildren.push(instance.container);
          }
        });
        updateChildren(newChildren);
      }
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cx(poolStyle)
  }, children);
});
var Notification = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: notificationStyle,
    onAnimationEnd: props.unMount
  }, typeof props.content === 'string' ? /*#__PURE__*/React.createElement("span", null, props.content) : props.content);
});
export default message;